import format from 'root-core/utils/text/stringFormatFilter.js'
import BaseTabSchema from 'root-packages/tabSchemaValidation/baseTabSchema.js'

class ReferralSchema extends BaseTabSchema {
  constructor (options) {
    super(options)
    this.config = options.config
  }

  advocateId () {
    const alias = 'advocate code' // true property name: advocateId
    return (value) => {
      if (!/^\d+$/.test(value)) {
        return format(this.config.errorMessages.number, alias)
      }
      if (value.length > 10) {
        return format(this.config.errorMessages.maxLength, 10, alias)
      }
    }
  }

  buildSchema () {
    return {
      referral: {
        advocateId: this.advocateId(),
      },
      leadPassenger: {
        emailAddress: this.email(),
      },
    }
  }
}

export default ReferralSchema
